module.exports = __webpack_public_path__ + "img/IT0000293147131.b317dc80.png";